import { render, staticRenderFns } from "./RoleContainer.vue?vue&type=template&id=c1882b92"
import script from "./RoleContainer.vue?vue&type=script&lang=js"
export * from "./RoleContainer.vue?vue&type=script&lang=js"
import style0 from "./RoleContainer.vue?vue&type=style&index=0&id=c1882b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports